import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import { useToast } from '../../context/ToastContext';
import '../../App.css';
import GroupForm from '../../components/forms/GroupForm';
import { translateError } from '../../utils/errorMessages';

const GroupCreatePage: React.FC = () => {
  const { t } = useTranslation();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const submitHandler = async (data: { name: string; description: string; activityId: number | null }) => {
    setLoading(true);
    setError(null);

    try {
      await api.groups.create(data);
      setLoading(false);
      addToast(t('groups.createTitle') + ' - ' + t('common.save') + '!', 'success');
      navigate('/admin/groups'); // Redirect back to the groups list after creation
    } catch (err: any) {
      const errorMessage = translateError(err, t);
      setError(errorMessage);
      addToast(t('common.error') + ': ' + errorMessage, 'error');
      setLoading(false);
    }
  };

  return (
    <div className="admin-form-page">
      <h2>{t('groups.createTitle')}</h2>
      {error && <p className="error-message">{t('common.error')}: {error}</p>}
      <GroupForm
        onSubmit={submitHandler}
        loading={loading}
        submitButtonText={t('groups.createButton')}
      />
      <Link to="/admin/groups" className="form-link">{t('groups.goBack')}</Link>
    </div>
  );
};

export default GroupCreatePage;